import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, FormGroup, Input, Row, Modal, UncontrolledTooltip } from "reactstrap";
import EditButton from "./EditButton";
import CreatableSelect from 'react-select/creatable';
import ReactDatetime from "react-datetime";
import moment from 'moment';


const MaterialArchiveTable = ({ materials, displayType, displayUnit, submitEdit, typeLoading, handleCreateUnit, handleCreateMaterial }) => {
    const valueConvert = (val) => {
        let nr = Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",")
        return nr === "NaN" ? " X " : nr
    }
    const [idtoEditArchive, setIdEditArchive] = React.useState(null)
    const [formValuesEditArchive, setFormValuesEditArchive] = React.useState({
        company_index_edit: "",
        name_edit: "",
        'm_type_edit': "",
        'unit_type_edit': "",
        unit_price_edit: null,
        ile_szt_edit:null,
        date_mat_edit:""
    })
    const setIdelement = (elem) => {
        let temp = {
            company_index_edit: elem.company_index,
            name_edit: elem.name,
            'm_type_edit': elem.m_type,
            'unit_type_edit': elem.unit_type,
            unit_price_edit: elem.unit_price,
            ile_szt_edit : elem.ile_szt,
            date_mat_edit:elem.date_mat=='1900-01-01'?'':elem.date_mat

        }
        setIdEditArchive(elem.id, setFormValuesEditArchive(temp))
    }
    const changeValueInEditForm = (e) => {
        setFormValuesEditArchive((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues[e.target.id] = e.target.value;
            return prevLoginValues;
        });
    }
    const handleEdit = (id) => {
        submitEdit(formValuesEditArchive, idtoEditArchive)
        setIdEditArchive(null)
    }
    return (
        <table className='table table-border tableWycena'>
            <thead className=''>
                <tr className=''>
                    <th className="headerColor" style={{width:"20%"}}>Indeks materiału</th>
                    <th className="headerColor" style={{width:"20%"}}>Materiał/lek/środek spożywczy specjalnego <br />przeznaczenia
                        żywieniowego/wyrób medyczny
                    </th>
                    <th className="headerColor">Typ</th>
                    <th className="headerColor">Jednostka <br /> miary</th>
                    <th className="headerColor" style={{width:'10%'}}>Cena jednostki <br /> miary w zł</th>
                    <th className="headerColor" style={{width:'10%'}}>Data <br /> obowiązywania</th>
                    <th className="headerColor">Opcje</th>
                </tr>
            </thead>
            <tbody>
                {materials && Object.getOwnPropertyNames(materials).length !== 0 && materials.map((elem) => {
                    return <>
                        {idtoEditArchive !== elem.id ? <tr>
                            <td>{elem.company_index}</td>
                            <td>{elem.name}</td>
                            <td>{displayType.find(item => item.value === elem.m_type) ? displayType.find(item => item.value === elem.m_type).label : elem.m_type}</td>
                            <td>{displayUnit.find(item => item.value === elem.unit_type) ? displayUnit.find(item => item.value === elem.unit_type).label : elem.unit_type}
                                {elem.unit_type_name === "opakowanie" || elem.unit_type_name === "Opakowanie" ? <>-{elem.ile_szt} szt.</> : <></>}</td>
                            <td className='rightAlignCell'>{valueConvert(elem.unit_price)}</td>
                            <td>{elem.date_mat !== '1900.01.01' ? elem.date_mat:""}</td>
                            {idtoEditArchive !== elem.id ? <td style={{ whiteSpace: 'nowrap' }} className='text-center'>
                                <EditButton idx={elem.id} elem={elem} edit={setIdelement} />
                                </td>
                                :
                                <td>
                                    <span style={{ marginRight: "5px", cursor: "pointer" }} onClick={() => {
                                        setIdEditArchive(null)
                                    }}>
                                        Anuluj</span>&nbsp;&nbsp;<span style={{ marginLeft: "5px" }}>OK</span></td>}
                        </tr> : <tr>
                            <td>
                                <Input
                                    className="border-input"
                                    type="text"
                                    id="company_index_edit"
                                    value={formValuesEditArchive['company_index_edit']}
                                    onChange={e => changeValueInEditForm(e)}

                                />
                            </td>
                            <td>
                                <Input
                                    className="border-input"
                                    type="text"
                                    id="name_edit"
                                    value={formValuesEditArchive['name_edit']}
                                    onChange={e => changeValueInEditForm(e)}


                                /></td>
                            <td><CreatableSelect
                                className='select-wycena'
                                isDisabled={typeLoading}
                                isLoading={typeLoading}
                                placeholder={"Wybierz..."}
                                formatCreateLabel={function formatCreateLabel(inputValue) {
                                    return "Dodaj \"".concat(inputValue, "\"");
                                }}
                                onChange={e => {
                                    setFormValuesEditArchive((prevState) => {
                                        const prevLoginValues = { ...prevState };
                                        prevLoginValues["m_type_edit"] = e.value;
                                        return prevLoginValues;
                                    });

                                }}
                                noOptionsMessage={({ inputValue }) => !inputValue ? "Zacznij pisać aby dodwać nową jednostkę" : "Brak wyników"}
                                onCreateOption={e => handleCreateMaterial(e)}
                                options={displayType}
                                value={displayType.find(item => item.value === formValuesEditArchive['m_type_edit'])}
                            /></td>
                            <td>
                                <CreatableSelect
                                    className='select-wycena'
                                    isDisabled={typeLoading}
                                    isLoading={typeLoading}
                                    placeholder={"Wybierz..."}
                                    formatCreateLabel={function formatCreateLabel(inputValue) {
                                        return "Dodaj \"".concat(inputValue, "\"");
                                    }}
                                    onChange={e => {
                                        setFormValuesEditArchive((prevState) => {
                                            const prevLoginValues = { ...prevState };
                                            prevLoginValues["unit_type_edit"] = e.value;
                                            return prevLoginValues;
                                        });

                                    }}
                                    noOptionsMessage={({ inputValue }) => !inputValue ? "Zacznij pisać aby dodwać nową jednostkę" : "Brak wyników"}
                                    onCreateOption={e => handleCreateUnit(e)}
                                    options={displayUnit}
                                    value={displayUnit.find(item => item.value === formValuesEditArchive['unit_type_edit'])}
                                />
                                {displayUnit.find(item => item.value === formValuesEditArchive['unit_type_edit']).label === "opakowanie" || displayUnit.find(item => item.value === formValuesEditArchive['unit_type_edit']).label === "Opakowanie" ?
                                    <div style={{ margin: "5px" }}>Ile szt.:
                                    <Input
                                            style={{ width: "60%", height: "80%", display: "inline" }}
                                            className="border-input"
                                            placeholder={`${""}`}
                                            type="text"
                                            id="ile_szt_edit"
                                            value={formValuesEditArchive['ile_szt_edit']}
                                            onChange={(e) => changeValueInEditForm(e)}
                                        /></div> : <></>}

                            </td>
                            <td className='rightAlignCell'><Input
                                className="border-input"
                                type="number"
                                id="unit_price_edit"
                                value={formValuesEditArchive['unit_price_edit']}
                                onChange={e => changeValueInEditForm(e)}

                            /></td>
                            <td>
                            <ReactDatetime
                                inputProps={{
                                    className: "form-control",
                                    placeholder: "data obowiązywania",
                                }}
                                dateFormat={"YYYY-MM-DD"}
                                timeFormat={false}
                                locale="pl"
                                id='date_mat_edit'
                                onChange={(e) => {
                                    changeValueInEditForm({'target': {value: moment(e).format('YYYY-MM-DD'), id: 'date_mat_edit'}})
                                }}
                                value={formValuesEditArchive['date_mat_edit']}
                                className='dateSelectWycena'
                            />
                            </td>
                            <td style={{ whiteSpace: 'nowrap' }} className='text-center'>
                                <Button
                                    className="btn-link "
                                    color="danger"
                                    data-toggle="tooltip"
                                    size="sm"
                                    type="button"
                                    onClick={() => {
                                        setIdEditArchive(null)
                                    }}
                                >
                                    <i className="fas fa-times"></i>
                                </Button>

                                <Button
                                    className="btn-link "
                                    color="success"
                                    data-toggle="tooltip"
                                    size="sm"
                                    type="button"
                                    onClick={(e) => {
                                        handleEdit(elem.id)
                                    }}
                                >
                                    <i className="fas fa-check"></i>
                                </Button>

                            </td>
                        </tr>}

                    </>
                })}
            </tbody>
        </table>

    )
}
export default MaterialArchiveTable;
